import { Link } from 'react-router-dom'
import { useLanguage } from '@/i18n/LanguageContext'
import { navItems } from './nav'
import { resolveNavHref } from './resolveNavHref'
import { GlowRouterLink } from '@/components/ui/GlowButton'
import { LogoMark } from '@/components/ui/LogoMark'

/**
 * Floating rounded pill nav — confirmed identical across every Stitch page
 * (services_pricing, about_me, portfolio): bg-white/10, backdrop-blur-xl,
 * border border-white/10, rounded-full, mt-6, amber glow shadow.
 */
export function DesktopNav() {
  const { lang, setLang, t } = useLanguage()

  return (
    <nav
      className="glow-ring hidden lg:inline-flex fixed top-6 left-1/2 -translate-x-1/2 z-50 items-center gap-0 rounded-pill
                 border border-white/10 bg-white/10 px-1.5 py-1.5 backdrop-blur-xl whitespace-nowrap max-w-[95vw]
                 shadow-[0_0_30px_rgba(255,185,99,0.1)]"
    >
      <Link to={resolveNavHref('#top', lang)} className="flex items-center gap-1.5 px-2.5 py-2 font-serif text-base tracking-tight text-foreground shrink-0">
        <LogoMark className="h-5 w-5 shrink-0" />
        EA Studio
      </Link>

      <ul className="flex items-center gap-0 px-1">
        {navItems.slice(0, -1).map((item) => (
          <li key={item.href}>
            <Link
              to={resolveNavHref(item.href, lang)}
              className="block px-2.5 py-2 text-[13px] text-foreground-muted transition-all duration-normal
                         hover:scale-105 hover:text-accent-fire active:scale-95"
            >
              {t(item.labelKey)}
            </Link>
          </li>
        ))}
      </ul>

      <div className="flex items-center gap-2 border-l border-white/10 pl-3 shrink-0">
        <button
          type="button"
          onClick={() => setLang(lang === 'bs' ? 'en' : 'bs')}
          className="px-1.5 py-1.5 text-sm text-foreground-muted transition-colors hover:text-accent-fire"
          aria-label="Switch language"
        >
          {lang === 'bs' ? 'EN' : 'BS'}
        </button>
        <GlowRouterLink to={resolveNavHref('/kontakt', lang)} className="px-4 py-2 text-xs">
          {t('nav-cta')}
        </GlowRouterLink>
      </div>
    </nav>
  )
}
